import React from 'react';
import { Form } from 'react-bootstrap';

export const QuestionLabel: React.FC<React.PropsWithChildren<unknown>> = ({
  children,
}) => (
  <Form.Label className="h3">
    <strong>{children}</strong>
  </Form.Label>
);
